/**
 * 탈퇴 요청 관리 API
 */
import { apiClient } from '@/shared/api/client';
import {
    GetWithdrawRequestListResponseDto
} from '../types/userWithdraw.types';
import { getItem } from '@/shared/utils/storage';

const BASE_PATH = '/api/v1/system/user-withdrawal';

/**
 * 탈퇴 요청 승인 DTO
 */
export type ApproveWithdrawalRequestDto = {
    riderId: string;
    suppId: string;
    insertUserId?: string;
};

/**
 * 탈퇴 요청 승인 응답 DTO
 */
export type ApproveWithdrawalResponseDto = {
    riderId: string;
    suppId: string;
    success: boolean;
    message: string;
};

/**
 * 탈퇴 요청 관리 API 서비스
 */
export const userWithdrawApi = {
    /**
     * 탈퇴 요청 목록 조회
     * GET /api/v1/system/user-withdrawal/list
     */
    getWithdrawRequestList: async (params?: {
        riderName?: string;
        suppName?: string;
        contStatus?: string;
        withdrawalStatusCd?: string;
    }): Promise<GetWithdrawRequestListResponseDto> => {
        const response = await apiClient.get<GetWithdrawRequestListResponseDto>(
            `${BASE_PATH}/list`,
            { params }
        );
        return response.data;
    },

    /**
     * 탈퇴 요청 승인
     * POST /api/v1/system/user-withdrawal/approve
     */
    approveWithdrawal: async (requests: ApproveWithdrawalRequestDto[]): Promise<ApproveWithdrawalResponseDto[]> => {
        // localStorage에서 userId 가져오기
        const userId = getItem<string>('USER_ID');
        // 각 request에 insertUserId 추가
        const requestsWithInsertUserId = requests.map(request => ({
            ...request,
            insertUserId: userId || ''
        }));
        const response = await apiClient.post<ApproveWithdrawalResponseDto[]>(
            `${BASE_PATH}/approve`,
            requestsWithInsertUserId
        );
        return response.data;
    }
};

